import { useCallback, useState } from 'react'
import { basePixiImports } from '../../utils/import/import-pixi'
import { setPreloadedGameWrapper } from '../../../game/preloadedGame'
import useStateControls from '../../../../hooks/useStateControls'
import CustomBridge from '../../../../controllers/bridge/CustomBridge'
import { useTranslation } from '../../../../translations'

// Имена чанков позволяют обфусцировать игры отдельно от общих библиотек.
const WRAPPER_IMPORTS = {
  memories: () => import(/* webpackChunkName: "game-memories" */ '../../../../components/scenes/memories/src/Wrapper'),
  match3: () => import(/* webpackChunkName: "game-match3" */ '../../../../controllers/match3/Wrapper'),
  platform: () => import(/* webpackChunkName: "game-platform" */ '../../../../controllers/platformerController/Wrapper'),
  jumper: () => import(/* webpackChunkName: "game-jumper" */ '../../../../controllers/doodle/Wrapper'),
}

export function useLoadGameController() {
  const [isPending, setIsPending] = useState(false)
  const { setState } = useStateControls()
  const { t } = useTranslation()

  const loadGame = useCallback(
    async (game) => {
      setIsPending(true)

      try {
        await basePixiImports()

        const importGameWrapper = WRAPPER_IMPORTS[game]

        const { default: WrapperClass } = await importGameWrapper()
        const wrapper = WrapperClass.instance

        await wrapper.init()
        wrapper._initialized = true

        setPreloadedGameWrapper(game, wrapper)

        await new Promise((resolve) => setTimeout(resolve, 0))

        setState(game)
      } catch {
        CustomBridge.instance.send({
          name: 'SHOW_NOTIFICATION',
          type: 0,
          data: {
            hasCloseButton: false,
            text: t('game.notification.loadingError'),
          },
        })
      } finally {
        setIsPending(false)
      }
    },
    [setState, t],
  )

  return { loadGame, isPending }
}
